/* eslint-disable @typescript-eslint/naming-convention */
const SHOULD_HIDE_UNSELECTED_CHECKBOXES_IN_SUMMARY = Boolean(process.env.REACT_APP_HIDE_UNSELECTED_CHECKBOXES_IN_SUMMARY);

export { SHOULD_HIDE_UNSELECTED_CHECKBOXES_IN_SUMMARY };
